export const SET_IDLE = '[API Reducer] Reset Call Status';

export function resetRequest(statusRequestName) {
  return {
    type: SET_IDLE,
    payload: statusRequestName,
  };
}
